import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';

@Injectable({
  providedIn: 'root'
})
export class LocationDataService {

  private uri: string = `${environment.apiUrl}location/log`;
  private osrmUrl = 'http://router.project-osrm.org/route/v1/driving/'; // URL de l'API OSRM

  constructor(
    private http: HttpClient
  ) {

  }

  getLocation(parameters: {[param: string]:  string | string|string | string[]}): Observable<any> {
    return this.http.get(this.uri + '/' + parameters.day + '/' + parameters.month + '/' + parameters.year + '/' + parameters.phoneNumber);
  }


  // Fonction pour obtenir l'itinéraire entre deux points
  getRoute(start: {lat: any, lon: any}, end: {lat: any, lon: any}): Observable<any> {
    const url = `${this.osrmUrl}${start.lon},${start.lat};${end.lon},${end.lat}?overview=full&geometries=geojson`;
    return this.http.get<any>(url);
  }
}
